<nb-layout>
  <nb-layout-column>
    <div class="row top" *ngIf="!this.showRegistration">
      <div *ngIf="!authError" class="col text-center"><h6>Đang xác thực...</h6></div>
      <div *ngIf="!!authError" class="col text-center auth-error">
        <span>
          <nb-icon icon="alert-triangle-outline"></nb-icon>
        </span>
        <h6>Có lỗi xảy ra. Xin thử đăng nhập bằng cách khác!</h6>
      </div>
    </div>
    <nb-card *ngIf="this.showRegistration">
      <nb-card-header
        ><nb-icon icon="checkmark-square-outline"></nb-icon> Đăng ký thông tin cho lần đăng nhập đầu
        tiên</nb-card-header
      >
      <nb-card-body>
        <div *ngIf="step == 1">
          <div class="description">Vui lòng nhập số điện thoại của bạn...</div>
          <div class="row">
            <div class="col-12 text-center">
              <input nbInput type="text" fieldSize="giant" placeholder="Số điện thoại" [(ngModel)]="phoneNumber" />
            </div>
          </div>
        </div>
        <div *ngIf="step == 2">
          <div class="description">Kiểm tra tin nhắn và nhập mã xác thực mà bạn nhận được...</div>
          <div class="row">
            <div class="col-12 text-center">
              <input nbInput type="text" fieldSize="giant" placeholder="Mã xác thực" [(ngModel)]="verifyCode" />
            </div>
          </div>
        </div>
        <div *ngIf="step == 3">
          <div class="description">Vui lòng cung cấp thông tin cá nhân của bạn...</div>
          <div class="row row-field">
            <div class="col col-sm-4 col-12">
              <div class="title">Tên Thánh</div>
            </div>
            <div class="col col-sm-8 col-12">
              <input nbInput type="text" placeholder="Tên Thánh" [(ngModel)]="saintsName" />
            </div>
          </div>
          <div class="row row-field">
            <div class="col col-sm-4 col-12">
              <div class="title">Họ</div>
            </div>
            <div class="col col-sm-8 col-12">
              <input nbInput type="text" placeholder="Họ" [(ngModel)]="lastName" />
            </div>
          </div>
          <div class="row row-field">
            <div class="col col-sm-4 col-12">
              <div class="title">Tên</div>
            </div>
            <div class="col col-sm-8 col-12">
              <input nbInput type="text" placeholder="Tên" [(ngModel)]="firstName" />
            </div>
          </div>
          <div class="row row-field">
            <div class="col col-sm-4 col-12">
              <div class="title">Ngày sinh</div>
            </div>
            <div class="col col-sm-8 col-12">
              <input
                nbInput
                placeholder="Ngày sinh"
                [nbDatepicker]="dateTimePicker"
                [(ngModel)]="dateOfBirth"
                style="max-width: inherit"
              />
              <nb-datepicker #dateTimePicker></nb-datepicker>
            </div>
          </div>
          <div class="row row-field">
            <div class="col col-sm-4 col-12">
              <div class="title">Giới tính</div>
            </div>
            <div class="col col-sm-8 col-12">
              <nb-radio-group [(value)]="gender">
                <nb-radio value="1">Nam</nb-radio>
                <nb-radio value="0">Nữ</nb-radio>
              </nb-radio-group>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center error">
            <span *ngIf="errorMessage">{{ errorMessage }}</span>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-12 text-center action">
            <button *ngIf="this.step > 1" nbButton status="info" (click)="onButtonPrevClick()">
              <nb-icon icon="arrowhead-left-outline"></nb-icon>
              Quay lại
            </button>
            <button nbButton status="info" (click)="onButtonNextClick()">
              {{ this.step === 3 ? 'Hoàn tất' : 'Tiếp theo' }}
              <nb-icon icon="{{ this.step === 3 ? 'checkmark-outline' : 'arrowhead-right-outline' }}"></nb-icon>
            </button>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </nb-layout-column>
</nb-layout>
